var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.977 10.3821C14.2441 10.6436 14.2441 11.0735 13.977 11.3349L13.7793 11.5285C13.5201 11.7822 13.1057 11.7822 12.8466 11.5285L8.46365 7.23797L4.08075 11.5285C3.82159 11.7822 3.40719 11.7822 3.14803 11.5285L2.95031 11.3349C2.68323 11.0735 2.68323 10.6436 2.95031 10.3821L7.99729 5.44153C8.25645 5.18784 8.67086 5.18784 8.93001 5.44153L13.977 10.3821Z",
    fill: "#0C002C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.12519 10.5608C2.95827 10.7242 2.95827 10.9929 3.12519 11.1563L3.32292 11.3498C3.48489 11.5084 3.74389 11.5084 3.90586 11.3498L8.46365 6.88812L13.0214 11.3498C13.1834 11.5084 13.4424 11.5084 13.6044 11.3498L13.8021 11.1563C13.969 10.9929 13.969 10.7242 13.8021 10.5608L8.75512 5.62018C8.59315 5.46163 8.33415 5.46163 8.17218 5.62018L3.12519 10.5608ZM2.77543 11.5136C2.40819 11.1541 2.40819 10.563 2.77543 10.2035L7.82241 5.26288C8.17875 4.91406 8.74856 4.91406 9.10489 5.26288L14.1519 10.2035C14.5191 10.563 14.5191 11.1541 14.1519 11.5136L13.9542 11.7071C13.5978 12.056 13.028 12.056 12.6717 11.7071L8.46365 7.58782L4.25563 11.7071C3.89929 12.056 3.32949 12.056 2.97315 11.7071L2.77543 11.5136Z",
    fill: "#0C002C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/upArrow.9927432011422713dd15941735901bad.svg";
export { ForwardRef as ReactComponent };